import React, { Component } from 'react';

import './SubHeader.css'

class SubHeader extends Component {
  render() {
    return (
      <div className="SubHeader">
        <h2>Mobile Apps</h2>
      </div>
    );
  }
}

export default SubHeader;


// WEBPACK FOOTER //
// ./src/Containers/App/components/SubHeader.js